if (!customElements.get('ed-pillow-story')) {
  customElements.define('ed-pillow-story', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.video = this.querySelector('video');
      this.button = this.querySelector('.ed-pillow-story__motion');
      if (!this.video || !this.button) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.inView = false;
      this.button.hidden = false;
      this.video.addEventListener('play', () => this.updateControl(true), {signal});
      this.video.addEventListener('pause', () => this.updateControl(false), {signal});
      this.video.addEventListener('error', () => {
        this.video.removeAttribute('src');
        this.button.hidden = true;
      }, {signal});
      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.play();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }, {signal});
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.video.pause();
        else if (this.inView && !this.userPaused) this.play();
      }, {signal});
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else if (this.inView && !this.motion.matches && !this.userPaused) this.play();
      }, {signal});
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (this.inView && !document.hidden && !this.motion.matches && !this.userPaused) this.play();
        else this.video.pause();
      }, {threshold: 0.15});
      this.observer.observe(this.video);
    }
    async play() {
      if (!this.video.getAttribute('src')) {
        this.video.src = this.video.dataset.animation;
        this.video.load();
      }
      this.video.muted = true;
      try { await this.video.play(); }
      catch { this.updateControl(false); }
    }
    updateControl(playing) {
      this.button.setAttribute('aria-pressed', String(playing));
      this.button.querySelector('[data-motion-label]').textContent = playing ? 'Pause animation' : 'Play animation';
    }
    disconnectedCallback() {
      this.video?.pause();
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
